import React from "react";
import { Link } from "react-router-dom";
import { ESTADOS_PALETIZACION } from "../../../../../../../../../utility/constants";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const ActionsContent = ({
    item,
    EliminarPaletizacion,
    paletizacionCerrada,
}) => {
    const estado = item && item.estado;

    if (paletizacionCerrada) {
        return (
            <div className="table-actions">
                <Link to={`/produccion-v2/detalle-paletizacion/${item.id}`}>
                    <img
                        src={verIcon}
                        alt="Ver"
                        className="action_img"
                        title="Ver"
                    />
                </Link>
            </div>
        );
    }

    if (estado === ESTADOS_PALETIZACION.SIN_ENVIAR) {
        return (
            <div className="table-actions">
                <img
                    src={eliminarIcon}
                    alt="Eliminar"
                    className="action_img"
                    title="Eliminar"
                    onClick={() => EliminarPaletizacion(item.id)}
                />
                <Link to={`/produccion-v2/crear-paletizacion/${item.id}`}>
                    <img
                        src={editarIcon}
                        alt="Editar"
                        className="action_img"
                        title="Editar"
                    />
                </Link>
            </div>
        );
    } else if (
        estado === ESTADOS_PALETIZACION.PENDIENTE ||
        estado === ESTADOS_PALETIZACION.ACEPTADO_PARCIAL ||
        estado === ESTADOS_PALETIZACION.RECHAZADO ||
        estado === ESTADOS_PALETIZACION.ACEPTADO
    ) {
        return (
            <div className="table-actions">
                <Link to={`/produccion-v2/detalle-paletizacion/${item.id}`}>
                    <img
                        src={verIcon}
                        alt="Ver"
                        className="action_img"
                        title="Ver"
                    />
                </Link>
            </div>
        );
    } else {
        return null;
    }
};
